import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.17 Case 17</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="self_assessment_117"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number one, one, seven, or 117.
                This is a positive case. Beginning at the level of the
                cerebellum and moving superiorly, you immediately notice focal
                uptake in the posterior aspect of the head. This activity is not
                within the cerebral cortex and is located within the bone. If
                you’d like to confirm this, utilize the accompanying PET-CT
                fused images to ensure that, in fact, this activity is within
                the bone. Moving superiorly, we enter into the temporal lobes,
                seen here on the left and here on the right. Distinct white
                matter tracts are not identifiable on either side. There is loss
                of gray-white contrast throughout. Continuing to move
                superiorly, this pattern continues, with clear loss of
                gray-white contrast seen in the left and right temporal lobes.
                As we enter into the lower occipital region, focal uptake is
                seen on the left-hand side. The intense uptake, located within
                the occipital gray matter, seen here, exceeds that of the
                adjacent white matter. Therefore, this alone would make this
                case positive for moderate to frequent plaques. However, as we
                continue to evaluate the temporal and occipital regions, it is
                clear that there is loss of gray-white contrast throughout both.
                Moving superiorly and entering into the frontal lobes, it is
                also clear that there is loss of gray-white contrast on the
                right and the left. Distinct white matter tracts are not
                visualized on either side. Therefore, the frontal cortices are
                also positive for loss of gray-white contrast. Again moving
                superiorly, we can see on the right-hand side, here, in the most
                superior aspect of the occipital region, there continues to be
                loss of gray-white contrast. As we move into the parietal
                regions, however, white matter tracts are identifiable on the
                left- and on the right-hand side. Therefore, it is much harder
                to distinctly say that there is loss of gray-white contrast at
                this level. After reviewing all the slices, however, it is clear
                that there remains loss of gray-white contrast in the frontal,
                occipital, and temporal regions. Therefore, this case is
                positive. If you called this case negative, please review the
                case once again in the MIM Viewer, concentrating on the regions
                described.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-16"
          nextLesson="/module-3/module-3-0-18"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_845289640&entry_id=1_web35ahz&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_web35ahz"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
